export const minifyHtmlString = (html) => {
    return html
        .split('\n')
        .map((s) => s.trim())
        .join('');
};
export const formatFooter = (lines) => {
    return minifyHtmlString(`<div class="so-global-p1">
        ${lines.join('\n')}
      </div>`);
};
export const getClassicFooterHtmlBlocks = (content) => {
    const { dontReply, helpCenter, helpCenterUrl, privacyPolicy, privacyPolicyUrl, termsOfUse, termsOfUseUrl, companyAddressLine, } = content;
    const FONT_COLOUR = '#2D2D2D';
    const COMMON_STYLE = `line-height: 2.1em; color: ${FONT_COLOUR}; font-size: 13px`;
    const getStyledWrapper = (innerHtml) => `<p style="text-align: center" class="so-global-p1">${innerHtml}</p>`;
    const getSingleLine = (text) => getStyledWrapper(`<span style="${COMMON_STYLE}">${text}</span>`);
    const getLinkTag = (text, url, divider) => {
        const dividerStyle = divider
            ? `border-${divider}: 1px solid ${FONT_COLOUR}`
            : 'border: none';
        return `<a target="_blank" rel="noopener noreferrer" href="${url}">
      <span style="text-decoration: underline; ${COMMON_STYLE};${dividerStyle}; padding: 0 8px;">
        ${text}
      </span>
    </a>`;
    };
    const dontReplyLine = dontReply ? getSingleLine(dontReply) : '';
    const addressLine = companyAddressLine
        ? getSingleLine(companyAddressLine)
        : '';
    const links = [
        [helpCenter, helpCenterUrl],
        [privacyPolicy, privacyPolicyUrl],
        [termsOfUse, termsOfUseUrl],
    ].filter((linkParams) => Boolean(linkParams[0] && linkParams[1]));
    const linkTags = links.map(([text, url], i) => {
        const isLastLink = i === links.length - 1;
        return getLinkTag(text, url, isLastLink ? undefined : 'right');
    });
    const linksLine = linkTags.length > 0 ? getStyledWrapper(linkTags.join('\n')) : '';
    return { addressLine, linksLine, dontReplyLine };
};
//# sourceMappingURL=utils.js.map